// @ts-ignore esModuleInterop
import React, { useCallback, useMemo, useState } from 'react'
// @ts-ignore no types
import _, { set } from 'lodash'
// @ts-ignore no types
import instrument from '@adc/instrument'
import type { primitives } from '@adc/blueprint'
import {
  Button,
  Modal,
  hooks,
  Text,
  // @ts-ignore no types
} from '@adc/ui-adc'
import {
  REGISTER_TO_BID,
  REGISTER_REDIRECT_URL_ACTION,
  REDIRECT_ACTION_KEY,
} from 'common/statics'
import {
  handleSaveProperty,
  handleRegistration as handleReg,
} from 'common/modules/auctionDetails/common'
// @ts-ignore no types
import { connect } from 'react-redux'
import _cx from 'classnames/bind'
import {
  PropertyPageActionsType,
  usePropertyContext,
} from 'common/context/property'
import { useListingContext } from 'common/context/listing'
import { getRegistrationRestrictedValues } from '../../../common/utils/listing'
// @ts-ignore no types
import congratulationsGif from '../../../common/images/congratulation-success-loop-once.gif'
import analytics from '../../services/analytics'
import { withModalHooks } from '../../hooks/useModalFeatures'
// @ts-ignore no types
import cls from './styles.scss'
import FirstLookFlow from './firstLookFlow'

const cx = _cx.bind(cls)

export const REGISTRATION_LIMIT_REACHED = 'REGISTRATION_LIMIT_REACHED'

// source used for analytics, used to support both mao and registration but now just registration
// TODO: remove this and the need for it across all of pdp, but that may require touching a lot of files
const source = () => 'bidderRegistration'
interface FirstLookModalButtonProps {
  user: primitives.AuctionUser
  featureFlags: Record<string, unknown>
  showFirstLookModal: boolean
  pushAuthQueueItem: (args: any) => void
  pushOnboardingQueueItem: (args: any) => void
  toggleAuthModal: (args: any) => void
  size?: 'large' | 'small' | 'medium' | 'marshmallow'
  elmId?: string
  text?: string
}

const FirstLookModalButton = ({
  user,
  featureFlags,
  showFirstLookModal,
  pushAuthQueueItem = () => {},
  pushOnboardingQueueItem = () => {},
  toggleAuthModal = () => {},
  size = 'large',
  elmId = '',
  text = '',
}: FirstLookModalButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { listing } = useListingContext()
  const { property, propertyActions } = usePropertyContext()
  const [isCurrentUserFirstLookQualified, setIsCurrentUserFirstLookQualified] =
    useState(listing.is_current_user_first_look_qualified)

  const breakpoints = hooks.useBreakpoints()
  const isMobile = breakpoints === 'mobile'

  const isSaved = property.is_currently_saved
  const initiateRegisterFlow = () => {
    let targetWhenSaved

    if (showFirstLookModal && !isCurrentUserFirstLookQualified) {
      targetWhenSaved = openModal
    } else {
      // no modal, just got straight through to reg
      targetWhenSaved = handleRegistration
    }

    handleSave(propertyActions?.toggleSaveProperty, targetWhenSaved)
  }

  hooks.useMountEffect(() => {
    if (
      localStorage.getItem(REDIRECT_ACTION_KEY) === REGISTER_REDIRECT_URL_ACTION
    ) {
      initiateRegisterFlow()

      localStorage.removeItem(REDIRECT_ACTION_KEY)
    }
  })

  const openModal = () => {
    analytics.firstLookModal.start()
    setIsModalOpen(true)
  }

  // auto-saves property forcing login if needed
  const handleSave = (
    toggleSaveProperty:
      | PropertyPageActionsType['toggleSaveProperty']
      | undefined,
    callbackWhenDone?: (args?: any) => void
  ) => {
    if (user?.logged_in) {
      autoSaveProperty(toggleSaveProperty)
      callbackWhenDone?.()
    } else {
      pushAuthQueueItem([() => autoSaveProperty(toggleSaveProperty)])
      if (callbackWhenDone) pushOnboardingQueueItem([callbackWhenDone])
      toggleAuthModal('login')
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const autoSaveProperty = (
    toggleSaveProperty?: PropertyPageActionsType['toggleSaveProperty']
  ) => {
    if (!isSaved) {
      return handleSaveProperty({
        listing,
        property,
        saveProperty: toggleSaveProperty,
        source: source(),
      })
    }
  }

  // template version of handleRegistration...
  const handleRegistration = useCallback(() => {
    handleReg({
      actions: {
        pushAuthQueueItem,
        pushOnboardingQueueItem,
        toggleAuthModal,
      },
      listing,
      user,
      actionSource: 'register-to-bid',
    })()
    closeModal()
  }, [
    pushAuthQueueItem,
    pushOnboardingQueueItem,
    toggleAuthModal,
    listing,
    user,
    closeModal,
  ])

  const accountRestrictedAlertValues = getRegistrationRestrictedValues({
    listing,
    user,
  })

  const role:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'brand'
    | 'navigation'
    | 'navigation-light'
    | undefined = 'primary'

  const buttonProps = {
    elmId: elmId || 'registration_button',
    size,
    text: text || REGISTER_TO_BID,
    role,
    disabled: accountRestrictedAlertValues?.isRegistrationButtonDisabled,
  }

  return (
    <>
      <Button
        {..._.omit(buttonProps, 'text')}
        className={cx(size === 'large' ? 'large-fixed-button' : '')}
        onClick={initiateRegisterFlow}
      >
        {buttonProps.text}
      </Button>
      <Modal
        className={cx('modal')}
        elmId='make_offer_modal'
        open={isModalOpen}
        mobileTitleSkin='light'
        onClose={closeModal}
        size='small'
        closeOnDimmerClick={false}
        title={
          <Text size='huge' weight='medium'>
            First Look Program
          </Text>
        }
      >
        <FirstLookFlow
          elmId={elmId}
          user={user}
          property={property}
          featureFlags={featureFlags}
          isMobile={isMobile}
          size={size}
          onSaveFirstLookBuyerSelection={setIsCurrentUserFirstLookQualified}
          handleRegistration={handleRegistration}
          closeModal={closeModal}
        />
      </Modal>
    </>
  )
}

const mapStateToProps = (store: any) => {
  const { listing } = store
  const showFirstLookModal =
    Boolean(listing.listing_configuration?.is_first_look_enabled) &&
    Boolean(!listing.is_current_user_first_look_qualified)

  return {
    user: store.user,
    featureFlags: store.featureFlags as Record<string, unknown>,
    showFirstLookModal,
  }
}

const mergeProps = (stateProps: any, dispatchProps = {}, ownProps: any) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export default connect(
  mapStateToProps,
  null,
  mergeProps
)(withModalHooks(FirstLookModalButton))
